import clsx from "classnames";
import { Description } from "@/ui";
import classes from "../styles.module.scss";

/**
 * Coloured band above the table holding the tag pills, the table title, optional text and a right-hand badge.
 *
 * @param {boolean} [show] - Whether the band is rendered.
 * @param {Array} [tags] - Tag pills; each item holds a label.
 * @param {string} [title] - Title shown in the band.
 * @param {string} [text] - Rich text under the title.
 * @param {string} [badge] - Small pill shown on the right of the band.
 * @param {string} [color] - Fill key for the band background.
 * @returns {JSX.Element|null}
 */
export default function TableTitleBar({ show, tags = [], title, text, badge, color }) {
  if (!show) return null;

  const visibleTags = tags?.filter((tag) => !!tag?.label) ?? [];

  return (
    <div className={clsx(classes.table__titleBar, classes[`fill--${color}`])}>
      <div className={classes.table__titleBarMain}>
        {!!visibleTags.length && (
          <div className={classes.table__tags} data-sourceflow-prop="tags">
            {visibleTags.map((tag, index) => (
              <span key={tag?.id ?? index} className={classes.table__tag}>
                {tag.label}
              </span>
            ))}
          </div>
        )}

        {!!title && (
          <h2 className={classes.table__titleBarTitle} data-sourceflow-prop="titleBarTitle">
            {title}
          </h2>
        )}

        {!!text && (
          <div className={classes.table__titleBarText} data-sourceflow-prop="titleBarText">
            <Description description={text} className="mb-0" />
          </div>
        )}
      </div>

      {!!badge && (
        <span className={classes.table__badge} data-sourceflow-prop="badge">
          {badge}
        </span>
      )}
    </div>
  );
}
